import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login.component';

const routes: Routes = [
  { path: '', component: LoginComponent, data: { title: 'Dealpos x Marketplace'} },
  {
    path: 'ForgotPassword',
    loadChildren: () => import('../forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: '', redirectTo: '', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
